import { cn } from '@/lib/utils';
import type { VehicleListing } from '@/models/registry';
import { Button } from '../../ui/button';
import { WHOLE_SALE_OPTIONS_MAP } from './options';

export const VehicleWholeSaleStatusBadge = ({
  value,
  hideCopy = false,
  buttonRef,
  className,
  buttonVariant = 'ghost',
}: {
  value: VehicleListing['transaction_type'];
  hideCopy?: boolean;
  buttonRef?: React.RefObject<HTMLButtonElement | null>;
  className?: string;
  buttonVariant?: 'outline' | 'ghost';
}) => {
  const option = WHOLE_SALE_OPTIONS_MAP.find(
    (option) => option.value === value,
  );

  return (
    <Button
      variant={buttonVariant}
      className={cn('p-1 h-fit', className)}
      ref={buttonRef}
    >
      {option?.icon}
      {!hideCopy && (
        <p className="rounded text-xs text-gray-600">{option?.label}</p>
      )}
    </Button>
  );
};
